import {
  GET_INDIVIDUAL_TERMINAL_ASSESSMENT,
  GET_INDIVIDUAL_TERMINAL_ASSESSMENT_LOADING,
  CLEAR_INDIVIDUAL_TERMINAL_ASSESSMENT,
} from "../constants/Type";

const initialState = {
  assessment: null,
  loading: false,
};

const individualTerminalAssessmentReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_INDIVIDUAL_TERMINAL_ASSESSMENT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_INDIVIDUAL_TERMINAL_ASSESSMENT:
      return {
        ...state,
        assessment: payload,
        loading: false,
      };

    case CLEAR_INDIVIDUAL_TERMINAL_ASSESSMENT:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default individualTerminalAssessmentReducer;
